import { useEffect, useState, useCallback } from "react";
import "./App.css";
import Carousel from "./Carousel.js";
import Routing from './Router.js';
// CREDIT
// Component inspired by @BalintFerenczy on X
// https://codepen.io/BalintFerenczy/pen/KwdoyEN
  


function App3() {

  return (
    <>
      <Routing />
      </>
  );
}

export default App3;
